// import { DocumentCardConfig, getConfiguredDocumentTypes } from '@shared/utils/address';
// import { useState, useEffect } from 'react';

// /**
//  * Custom hook to get configured document types from localStorage
//  * 
//  * @returns {Object} Object containing document types and loading state
//  */
// export const useConfiguredDocumentTypes = () => {
//   const [documentTypes, setDocumentTypes] = useState<DocumentCardConfig[]>([]);
//   const [isLoading, setIsLoading] = useState<boolean>(true);
//   const [error, setError] = useState<Error | null>(null);

//   useEffect(() => {
//     try {
//       setIsLoading(true);
//       // Get document types from localStorage using the utility function
//       const types = getConfiguredDocumentTypes();
//       console.log('✅ Configured document types:', types);
//       setDocumentTypes(types);
//       setIsLoading(false);
//     } catch (err) {
//       console.error('❌ Error fetching document types:', err);
//       setError(err instanceof Error ? err : new Error('Failed to load document types'));
//       setIsLoading(false);
//     }
//   }, []);

//   return {
//     documentTypes,
//     isLoading,
//     error,
//   };
// };

import { DocumentCardConfig, getConfiguredDocumentTypes } from '@shared/utils/address';
import { useState, useEffect } from 'react';

/**
 * Custom hook to get configured document types from localStorage
 * 
 * @returns {Object} Object containing document types and loading state
 */
export const useConfiguredDocumentTypes = () => {
  const [documentTypes, setDocumentTypes] = useState<DocumentCardConfig[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    try {
      setIsLoading(true);
      // Get document types from localStorage using the utility function
      const types = getConfiguredDocumentTypes();
      console.log('✅ Configured document types:', types);
      
      // Verify that we have the complete codes
      types.forEach(type => {
        if (type.code) {
          console.log(`Document type "${type.name}" has code "${type.code}"`);
        } else {
          console.warn(`⚠️ Document type "${type.name}" is missing a code!`);
        }
      });
      
      setDocumentTypes(types);
      setIsLoading(false);
    } catch (err) {
      console.error('❌ Error fetching document types:', err);
      setError(err instanceof Error ? err : new Error('Failed to load document types'));
      setIsLoading(false);
    }
  }, []);

  return {
    documentTypes,
    isLoading,
    error,
  };
};